import { Clapperboard, Eye, ListTree, Mic, Send } from 'lucide-react';
import type { PlanStep } from '@/components/studio/plan/PlanSteps';
import type { Draft, DraftFields } from './draft';
import { chipById } from './chips';
import { pickedLookName } from './looks';

/** /start's working line while the home screen starts the video underneath it; the studio keeps it until Ivy acts. */
export const STARTING = 'Starting your video…';

export interface StagedPlan {
  reply: string;
  steps: PlanStep[];
  scenes: number;
}

/**
 * What /start shows before sign-in, worked out here without asking the server: an idea from the landing page brings
 * its own plan, and typed words get the same five stages every video goes through, with the look their words name.
 */
export function planFor(draft: Pick<Draft | DraftFields, 'prompt' | 'look' | 'chip'>): StagedPlan {
  const chip = chipById(draft.chip);
  const look = pickedLookName(draft.look);
  return {
    reply: chip?.reply ?? 'Here’s how I’ll make it:',
    scenes: chip?.scenes ?? 5,
    steps: [
      { id: 'plan', label: 'Plan', detail: chip?.plan ?? 'The story, scene by scene', state: 'current', icon: ListTree },
      { id: 'voice', label: 'Voice', detail: 'Narration in a natural voice', state: 'todo', icon: Mic },
      { id: 'build', label: 'Build', detail: look ? `Scenes in ${look}` : 'Scenes in a look that fits your idea', state: 'todo', icon: Clapperboard },
      { id: 'review', label: 'Review', detail: 'You check every scene before anyone sees it', state: 'todo', icon: Eye },
      { id: 'deliver', label: 'Deliver', detail: 'A link to share or embed', state: 'todo', icon: Send },
    ],
  };
}
